import {AbstractControl, FormGroup} from '@angular/forms';

export function mustMatch(controlName: string, matchingControlName: string): { [key: string]: any } | null {
  return (formGroup: FormGroup) => {
    const control: AbstractControl = formGroup.get(controlName);
    const matchingControl: AbstractControl = formGroup.get(matchingControlName);

    if (control.touched || control.dirty || matchingControl.touched || matchingControl.dirty) {
      if (control.value !== matchingControl.value) {
        return { mustMatch : { valid: false, value: matchingControl.value }};
      } else {
        return null;
      }
    }
  };
}

export function mobilePhoneNumberValidator(
  control: AbstractControl
): { [key: string]: any } | null {
  const valid = /^[1-9][0-9]{8}$/.test(control.value);
  return valid
    ? null
    : { invalidNumber: { valid: false, value: control.value } };
}

export function pwdValidator(
  control: AbstractControl
): { [key: string]: any } | null {
  let valid = true;
  if(control.touched){
     valid = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&_#+=^)(])[A-Za-z\d@$!_%*^?+=&#)(]{10,}$/.test(control.value);
  }
  return valid
    ? null
    : { invalidPwd: { valid: false, value: control.value } };
}

export function timeValidator(control: AbstractControl) {
  const value = control.value;
  const regex = new RegExp('^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$');
  const isValid = regex.test(value);
  return isValid ? null : {time: true};
}


export function noWhitespaceValidator(control: AbstractControl) {
  const isWhitespace = (control.value || '').trim().length === 0;
  const isValid = !isWhitespace;
  return isValid ? null : {'whitespace': true};
}
